<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    modelValue: [String, Number],
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus();
    }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
    <input
        ref="input"
        class="border-gray-300 focus:border-allday-dark-500 focus:ring-allday-dark-500 rounded-md shadow-sm disabled:cursor-not-allowed disabled:bg-gray-200 disabled:border-gray-700"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
</template>
